import React, { createRef } from "react";
import { getI18n } from "react-i18next";
import "./CellDropdown.scss";
import DownArrowIcon from "./icon-arrow-down.inline.svg";
import { FrameContextConsumer } from "react-frame-component";
import { Frame } from "src/providers/frame/withFrame";

const optionRender = (option: any, onSelect: (e: any) => void) => {
    return (
        <li key={`option${option.value}`} onClick={onSelect} data-value={option.value}>
            {option.text}
        </li>
    );
};

const isDescendant = (parent: Element, child: Element) => {
    let node = child.parentNode;
    while (node !== null) {
        if (node === parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};

const cellDropdownRender = (
    { isOpen, value, options, title }: any,
    close: () => void,
    toggleOpen: () => void,
    makeSelection: (e: any) => void
) => {
    const dropdownRoot = createRef<HTMLDivElement>();
    const optionItems = options.map((o: any) => optionRender(o, makeSelection));
    const handleBlur = (iframe: Frame) => {
        // IE11 hack, event.target is different than other browsers, so document.activeElement is used
        if (
            dropdownRoot.current &&
            iframe.document.activeElement &&
            dropdownRoot.current !== iframe.document.activeElement &&
            !isDescendant(dropdownRoot.current, iframe.document.activeElement)
        ) {
            close();
        }
    };

    let elementTitle = title;
    // Specifically in the case of specific cells like lease mileage, the title can come in as a function meant to be used for i18n
    // Currently this only affects the lease mileage cell.
    if (typeof elementTitle !== "string") {
        const i18n = getI18n();
        elementTitle = i18n.t("MyGarage.Cells.titles.viewOptions");
    }
    return (
        <FrameContextConsumer>
            {(iframe: Frame) => (
                <div
                    className={`CellDropdown ${isOpen ? "CellDropdown--open" : ""}`}
                    onBlur={() => handleBlur(iframe)}
                    ref={dropdownRoot}
                    tabIndex={0}
                    title={elementTitle}
                >
                    <div className="CellDropdown__launcher" onClick={toggleOpen}>
                        <p>{value}</p> <DownArrowIcon />
                    </div>
                    <ul className="CellDropdown__options">{optionItems}</ul>
                </div>
            )}
        </FrameContextConsumer>
    );
};

export default cellDropdownRender;
